"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { type ExternalToast, toast } from "sonner";

type ToastVariant = "success" | "info" | "warning" | "error" | "message" | "loading";
type ToastAction = { variant: "redirect"; label: string; url: string };

export const ToastOnMount = (props: {
  shouldExecute: boolean;
  variant: ToastVariant;
  message: string | React.ReactNode;
  action?: ToastAction | undefined;
}) => {
  if (!props.shouldExecute) {
    return null;
  }

  const { action, variant, message } = props;
  const router = useRouter();

  useEffect(() => {
    const timerId = setTimeout(() => {
      let data: ExternalToast = {};

      if (action && action.variant === "redirect") {
        data.action = {
          label: action.label,
          onClick: () => router.push(action.url)
        };
      } else {
        data = {};
      }

      if (variant === "success") {
        toast.success(message, data);
      } else if (variant === "info") {
        toast.info(message, data);
      } else if (variant === "warning") {
        toast.warning(message, data);
      } else if (variant === "error") {
        toast.error(message, data);
      } else if (variant === "message") {
        toast.message(message, data);
      } else if (variant === "loading") {
        toast.loading(message, data);
      }
    });

    return () => {
      clearTimeout(timerId);
    };
  }, [router.push, action, action?.label, action?.variant, action?.url, message, variant]);

  return null;
};
